<template>
  <div style="width: 100%; height: 100%" class="ma-0 pa-0 customscroll">
    <v-dialog v-model="dialogTimer" persistent width="290px">
      <v-time-picker v-if="dialogTimer" format="24hr" v-model="currentTime">
        <v-col class="ma-0 pa-0">
          <t-divider></t-divider>
          <v-row class="ma-2 pa-0" align="center" justify="center">
            <v-col cols="5" class="ma-0 pa-0" justify="start">
              <t-button :elevation="5" btnIcon="mdi-close" btnText="Отказ" :width="'100'" style="display: flex; cursor: pointer" @click.native="cancelClock()"> </t-button>
            </v-col>
            <v-col cols="2" class="ma-0 pa-0"></v-col>
            <v-col cols="5" class="ma-0 pa-0">
              <t-button :elevation="5" btnIcon="mdi-check" btnText="ОК" :width="'100'" style="display: flex; cursor: pointer" @click.native="setClock()"> </t-button>
            </v-col>
          </v-row>
        </v-col>
      </v-time-picker>
    </v-dialog>
    <v-row class="ma-1 pa-0">
      <t-button v-if="!editMode" :elevation="5" :class="'ma-2'" btnIcon="mdi-pencil" btnText="Редакция" :width="'180'" style="display: flex; cursor: pointer" @click.native="editMode = true"> </t-button>
      <t-button v-if="editMode" :elevation="5" :class="'ma-2'" :btnIcon="'mdi-plus-circle'" :btnText="'Добави график'" :width="'180'" style="display: flex; cursor: pointer" @click.native="addConfiguration()"> </t-button>
      <t-button v-if="editMode" :elevation="5" :class="'ma-2'" btnIcon="mdi-checkbox-marked-circle-outline" btnText="Запази" :width="'120'" style="display: flex; cursor: pointer" @click.native="saveConfigurations()"> </t-button>
    </v-row>
    <v-row class="ma-1 pa-0">
      <v-col class="ma-1 pa-0 px-1" cols="12" v-for="(s, idx) in schedules" :key="idx" justify="center">
        <v-card class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 mx-1" align="center">
            <v-tooltip v-if="editMode" :disabled="hideTooltips" bottom style="z-index: 10">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="ma-0 pa-0" :color="Colors.IconColor" icon x-small @click="removeConfiguration(idx)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              Премахване на графика за изпращане на одит
            </v-tooltip>
            <!-- <v-text-field class="ma-1 pa-0 centered-input" style="max-width: 40px;" v-text="'№ ' + (idx + 1)" readonly dense hide-details"></v-text-field> -->
            <v-text-field v-for="valIdx in s.Values.length" :key="valIdx" class="ma-1 pa-0 centered-input" style="max-width: 50px" v-model="s.Values[valIdx - 1]" readonly dense hide-details @click="showClock(idx, valIdx - 1)"></v-text-field>
            <v-tooltip v-if="editMode && s.Values.length > 0" :disabled="hideTooltips" bottom style="z-index: 10">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="ma-0 pa-0" :color="Colors.IconColor" icon small @click="removeLastHour(idx)">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </template>
              Премахване на последния час от графика
            </v-tooltip>
            <v-tooltip v-if="editMode && s.Values.length < 6" :disabled="hideTooltips" bottom style="z-index: 10">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="ma-0 pa-0" :color="Colors.IconColor" icon small @click="addNewHour(idx)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              Добавяне на допълнителен час към графика (Максимум 6 стойности)
            </v-tooltip>

            <!-- <t-button :elevation="5" :class="'ma-2 ml-8'" btnIcon="mdi-deskphone" @click.native="pickDevices(idx)" :btnText="'Избор на ФУВАС'" /> -->
          </v-row>
          <v-row class="ma-0 pa-0" align="center">
            <v-tooltip :disabled="hideTooltips" bottom style="z-index: 10">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="ma-1 pa-0" :class="editMode ? 'ml-8' : 'ml-3'" :color="Colors.IconColor" icon small @click="pickDevices(idx)">
                  <img :src="TremolVIcon" width="32" />
                </v-btn>
              </template>
              {{ editMode ? "Избор на устройства за текущия график" : "Устройства за текущия график" }}
            </v-tooltip>
            <span v-if="getDevs(idx)" class="subtitle-2">{{ getDevs(idx) }}</span>
            <span v-else class="subtitle-2">{{ "Няма избрани устройства за този график" }}</span>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
import { TelemetrySchedule } from "../../js/Telemetry";

export default {
  data() {
    return {
      editMode: false,
      reload: false,
      isDirty: false,
      devs: [],
      schedules: [],
      dialogTimer: false,
      currentTime: null,
      lastTime: null,
      currentSchedIdx: -1,
      currentPropIdx: -1,
    };
  },
  methods: {
    setFocus(on) {
      if (!on && this.isDirty == true) {
        this.dialogLoader.showInfo("Не сте записали промените, които сте направили в меню 'График за одит'.");
      }
    },
    reloadData() {
      this.devs = DataManager.getData(DataManager.DataType.devices, true)
        .filter((i) => i.IsFuvas && !i.IsOldFuvas)
        .map((d) => ({ id: d.id, Name: d.Name, TelemetryScheduleId: d.TelemetryScheduleId }));
      this.schedules = DataManager.getData(DataManager.DataType.user, true).settings2.telemetryschedules;
      this.editMode = false;
    },
    saveConfigurations() {
      this.schedules.forEach((s) => {
        s.Values.sort((a, b) => {
          if (!a) return 1;
          else if (!b) return -1;
          else return a.localeCompare(b);
        });
      });
      if (this.schedules.some((s) => s.Values.some((v) => !v))) {
        this.dialogLoader.showError("Има графици без избрани часове!");
        return;
      }
      var devsWChangedSched = DataManager.getData(DataManager.DataType.devices, true).filter((d) => d.IsFuvas && !d.IsOldFuvas && this.devs.find((dd) => dd.id == d.id && dd.TelemetryScheduleId != d.TelemetryScheduleId));
      //console.log(JSON.stringify(devsWChangedSched.map(d => d.Name)));
      var arr = [];
      devsWChangedSched.forEach((d) => {
        var dev = this.devs.find((dd) => dd.id == d.id);
        if (dev && dev.TelemetryScheduleId != null) {
          d.TelemetryScheduleId = dev.TelemetryScheduleId;
          var vals = this.schedules[dev.TelemetryScheduleId].Values.join(";");
          arr.push({
            devId: d.id,
            zfpCmds: "_T;H;W;" + vals,
            comment: "Telemetry schedule " + vals,
          });
        } else {
          d.TelemetryScheduleId = null;
          arr.push({
            devId: d.id,
            zfpCmds: "_T;H;S;",
            comment: "Telemetry schedule delete",
          });
        }
      });
      DataManager.setBatch(arr, (err) => {
        if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          DataManager.updateUserSettings(null, DataManager.getData(DataManager.DataType.user, true).settings2, null, null, null, (err2) => {
            if (err2.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
              DataManager.updateDevProfile(devsWChangedSched, (err3) => {
                if (err3.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
                  this.dialogLoader.showInfo("Успешен запис на графиците за одит.\nМоля, имайте в предвид, че смяната на графиците е ограничен брой.");
                  this.reloadData();
                  this.isDirty = false;
                } else {
                  this.dialogLoader.showError("Грешка при запис на одит графици!\n" + err3.toString());
                }
              });
            } else {
              this.dialogLoader.showError("Грешка при запис на одит графици!\n" + err2.toString());
            }
          });
        } else {
          this.dialogLoader.showError("Грешка при запис на одит графици!\n" + err.toString());
        }
      });
    },
    pickDevices(idx) {
      if (this.editMode) {
        this.dialog.show(
          "picker-view",
          this.devs,
          {
            title: "Избор на ФУВАС за график: " + this.schedules[idx].toString(),
            multiple: true,
            allowEmpty: true,
            toStringFn: (i) => {
              return i.Name + (i.TelemetryScheduleId != null ? " (" + this.schedules[i.TelemetryScheduleId] + ")" : "");
            },
            selected: this.devs.filter((d) => d.TelemetryScheduleId == idx),
            buttonCancelText: "Откажи",
            buttonOKText: "Запази",
          },
          (result) => {
            if (result != null) {
              this.isDirty = true;
              this.devs.forEach((d) => {
                if (result.indexOf(d) != -1) {
                  d.TelemetryScheduleId = idx;
                } else if (d.TelemetryScheduleId == idx) {
                  d.TelemetryScheduleId = null;
                }
              });
              // this.reload = true;
              // this.$nextTick(() => {
              //   this.reload = false;
              // });
            }
          }
        );
      }
    },
    addConfiguration() {
      this.isDirty = true;
      var id = this.schedules.length;
      this.schedules.push(new TelemetrySchedule());
      this.addNewHour(id);
    },
    removeConfiguration(idx) {
      this.dialog.show(
        "yes-no",
        null,
        {
          title: "Внимание",
          buttonYesText: "Да",
          buttonNoText: "Не",
          text: "Сигурни ли сте, че искате да премахнете графика?",
        },
        (result) => {
          if (result) {
            this.devs
              .filter((d) => d.TelemetryScheduleId != null)
              .forEach((d) => {
                if (d.TelemetryScheduleId == idx) {
                  d.TelemetryScheduleId = null;
                } else if (d.TelemetryScheduleId > idx) {
                  d.TelemetryScheduleId = d.TelemetryScheduleId - 1;
                }
              });
            this.schedules.splice(idx);
            this.isDirty = true;
            // var devsWChangedSched = DataManager.getData(DataManager.DataType.devices, true)
            //   .filter(d => d.TelemetryScheduleId != null)
            //   .forEach(d => {
            //     if (d.TelemetryScheduleId == idx) {
            //       d.TelemetryScheduleId = null;
            //     } else if (d.TelemetryScheduleId > idx) {
            //       d.TelemetryScheduleId = d.TelemetryScheduleId - 1;
            //     }
            //   });
            // DataManager.updateDevProfile(devsWChangedSched, err => {
            //   if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            //     DataManager.updateUserSettings(null, DataManager.getData(DataManager.DataType.user, true).settings2, null, err2 => {
            //       if (err2.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            //         this.schedules.splice(idx, 1);
            //         this.dialogLoader.show("Успешно изтриване на график");
            //       } else {
            //         this.dialogLoader.showError("Грешка при изтриване на график!\n" + err.toString());
            //       }
            //     });
            //   } else {
            //     this.dialogLoader.showError("Грешка при изтриване на график!\n" + err.toString());
            //   }
            // });
          }
        }
      );
    },
    removeLastHour(idx) {
      if (this.schedules[idx].Values.length == 0) {
        return;
      }
      this.schedules[idx].Values.splice(this.schedules[idx].Values.length - 1, 1);
      this.isDirty = true;
    },
    addNewHour(idx) {
      if (this.schedules[idx].Values.length == 6) {
        this.dialogLoader.showError("Достигнат е максимума от 6 стойности за този график!");
        return;
      }
      this.schedules[idx].Values.push("");
      this.$nextTick(() => {
        this.showClock(idx, this.schedules[idx].Values.length - 1);
      });
      this.isDirty = true;
    },
    showClock(scheduleIdx, propIdx) {
      this.currentSchedIdx = scheduleIdx;
      this.currentPropIdx = propIdx;
      this.currentTime = this.schedules[scheduleIdx].Values[propIdx];
      this.lastTime = this.currentTime;
      this.dialogTimer = true;
    },
    setClock() {
      this.schedules[this.currentSchedIdx].Values[this.currentPropIdx] = this.currentTime;
      this.dialogTimer = false;
      this.isDirty = true;
    },
    cancelClock() {
      this.currentTime = this.lastTime;
      this.$nextTick(() => {
        this.currentTime = null;
        this.dialogTimer = false;
      });
    },
    getDevs(idx) {
      return this.devs
        .filter((d) => !this.reload && d.TelemetryScheduleId == idx)
        .map((d) => d.Name)
        .join(", ");
    },
  },
  mounted() {
    this.reloadData();
  },
};
</script>

<style>
</style>